module.exports = __webpack_public_path__ + "img/UMMC.2a0b0f4b.svg";